import React, { useState } from 'react';
import { getBaseUrl } from '../../../api/risapi'; 

// Clean sub-component to handle image loading and fallbacks perfectly
const ProductImage = ({ imagePath, productName }) => {
    const [imageError, setImageError] = useState(false);

    // If no path is provided OR if the image failed to load, show the placeholder
    if (!imagePath || imageError) {
        return (
            <div 
                className="bg-light d-flex justify-content-center align-items-center border-bottom" 
                style={{ height: '120px', width: '100%' }}
            >
                <i className="ti ti-photo text-muted opacity-50" style={{ fontSize: '2.5rem' }}></i>
            </div>
        );
    }

    // Otherwise, attempt to load the actual image
    return (
        <img 
            src={`${getBaseUrl()}/storage/${imagePath}`} 
            alt={productName} 
            className="card-img-top border-bottom" 
            style={{ height: '120px', objectFit: 'cover', width: '100%' }}
            onError={() => setImageError(true)} // On failure, trigger the state change
        />
    );
};

const ProductGrid = ({ products, searchTerm, setSearchTerm, searchInputRef, addToCart }) => {
    return (
        <div className="card shadow-sm h-100">
            <div className="card-header bg-light d-flex justify-content-between align-items-center">
                <input 
                    type="text" 
                    className="form-control" 
                    placeholder="Search products by name or code..." 
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    ref={searchInputRef}
                />
            </div>
            {/* --- UPDATED HEIGHT --- */}
            <div className="card-body" style={{ height: 'calc(100vh - 220px)', overflowY: 'auto' }}>
                <div className="row g-3">
                    {Array.isArray(products) && products
                        .filter(p => p && p.name && p.name.toLowerCase().includes(searchTerm.toLowerCase()))
                        .map(product => {
                            const activeRate = (product.rates && product.rates.length > 0) ? product.rates[0] : {};
                            const finalPrice = activeRate.calculated_final_price || activeRate.base_price || product.current_price || 0;

                            return (
                                <div className="col-lg-3 col-sm-6" key={product.id}>
                                    <div 
                                        className="card h-100 border-primary cursor-pointer hover-effect overflow-hidden" 
                                        onClick={() => addToCart(product)}
                                    >
                                        {/* Seamless Image/Fallback component */}
                                        <ProductImage 
                                            imagePath={product.image_path} 
                                            productName={product.name} 
                                        />

                                        <div className="card-body text-center p-3">
                                            <h6 className="mb-1 text-truncate" title={product.name}>{product.name}</h6>
                                            <div className="text-muted small mb-2">Code: {product.code}</div>
                                            <div className="fw-bold text-success">₹{parseFloat(finalPrice).toFixed(2)}</div>
                                            <div className={`badge ${parseFloat(product.current_stock) > 0 || product.allow_negative_stock ? 'bg-success' : 'bg-danger'} mt-2`}>
                                                {/* Stock: {parseFloat(product.current_stock || 0).toFixed(2)} */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        </div>
    );
};

export default ProductGrid;